// AdminLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { Menu } from "lucide-react";
import api from "../utils/Api";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handlePlayClick = async () => {
    console.log("Recalculando horas...");
    try {
      const response = await api.post("/recalcular-horas");
      console.log("Recalculo exitoso:", response.data);
    } catch (error) {
      console.error("Error al recalcular horas:", error);
    }
  };

  // Bloquear scroll del body cuando el sidebar móvil está abierto
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
    document.body.style.overflowX = "hidden"; // bloquear scroll horizontal siempre
  }, [sidebarOpen]);

  return (
    <div
      className="d-flex vh-100"
      style={{
        backgroundColor: "#F5F5F5",
        overflowX: "hidden", // Bloquea scroll horizontal de todo el layout
      }}
    >
      {/* Sidebar escritorio */}
      <div
        className="d-none d-md-flex flex-column flex-shrink-0 shadow-sm"
        style={{ width: "250px", backgroundColor: "#FFFFFF" }}
      >
        <Sidebar />
      </div>

      {/* Sidebar móvil */}
      {sidebarOpen && (
        <div
          className="position-fixed top-0 start-0 vh-100 vw-100 bg-dark bg-opacity-50 d-md-none"
          onClick={() => setSidebarOpen(false)}
          style={{ zIndex: 1000 }}
        >
          <div
            className="position-relative h-100 shadow"
            style={{ width: "250px", backgroundColor: "#FFFFFF" }}
            onClick={(e) => e.stopPropagation()}
          >
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Contenido principal */}
      <div
        className="flex-grow-1 d-flex flex-column transition-transform"
        style={{
          transform: sidebarOpen ? "translateX(250px)" : "translateX(0)",
          transition: "transform 0.3s ease",
          overflow: sidebarOpen ? "hidden" : "auto", // Bloquea scroll mientras sidebar esté abierto
        }}
      >
        {/* Header */}
        <header
          className="d-flex align-items-center justify-content-between shadow-sm px-3 px-md-4"
          style={{
            height: "64px",
            backgroundColor: "#FFFFFF",
            borderBottom: "1px solid #F5F5F5",
          }}
        >
          {/* Botón menú solo en móvil */}
          <button
            className="btn d-md-none"
            style={{ color: "#FF7A00" }}
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={24} />
          </button>
          <div className="d-flex align-items-center gap-3">
            <span style={{ color: "#2C2C2C" }}>Admin</span>
            <div
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#FF7A00",
                color: "#FFFFFF",
                fontWeight: "500",
              }}
            >
              
            <form onSubmit={(e) => {e.preventDefault(); handlePlayClick();}}>
              <input type="submit" value="A" style={{ color:"white", border: 0, backgroundColor: "#FF7A00", borderRadius: "50%" }} />
            </form>
            </div>
          </div>
        </header>
        {/* Contenido dinámico */}
        <main
          className="flex-grow-1 p-3 p-md-4"
          style={{
            overflow: sidebarOpen ? "hidden" : "auto", // evita desplazamiento dentro del main
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
